import { Box, Typography } from "@mui/material";

export interface Lesson {
  id: number;
  title: string;
  description: string;
  content_text?: string | null;
  content_type: "article" | "course" | "video" | "audio";
  youtube_url?: string;
  duration?: string;
  image?: string;
}

interface ArticleReaderProps {
  lesson: Lesson;
}

export default function ArticleReader({ lesson }: ArticleReaderProps) {
  return (
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: 3,
        p: 2,
      }}
    >
      {/* Article Content */}
      <Box
        sx={{
          maxHeight: 500,
          overflowY: "auto",
          backgroundColor: "#F0F4F8",
          borderRadius: 3,
          p: 2,
          "&::-webkit-scrollbar": {
            width: 8,
          },
          "&::-webkit-scrollbar-track": {
            bgcolor: "#f0f0f0",
            borderRadius: 4,
          },
          "&::-webkit-scrollbar-thumb": {
            bgcolor: "#724E41",
            borderRadius: 4,
            "&:hover": {
              bgcolor: "#7a5f3d",
            },
          },
        }}
      >
        <Typography
          sx={{
            fontSize: "1rem",
            lineHeight: 1.8,
            color: "#333",
            whiteSpace: "pre-line",
          }}
        >
          {lesson.content_text || lesson.description}
        </Typography>
      </Box>
    </Box>
  );
}
